import { ENV } from 'configs';
import { HttpClient } from 'services';

export const httpClient = new HttpClient(ENV.API_ENDPOINT);
